import { useEffect } from 'react';
import { useGuidedTour } from '@/hooks/useGuidedTour';
import { useTourStore, isTourCompleted } from '@/stores/tourStore';
import { registerTourRestart } from '@/hooks/useTourRestart';
import type { DriveStep } from 'driver.js';

interface UseTourAutoStartOptions {
  tourId: string;
  steps: DriveStep[];
  delay?: number;
}

export function useTourAutoStart({ tourId, steps, delay = 500 }: UseTourAutoStartOptions) {
  const tour = useGuidedTour({ tourId, steps });

  // Register this tour's restart function for the help button
  useEffect(() => {
    const unregister = registerTourRestart(() => {
      useTourStore.getState().resetTour(tourId);
      tour.start();
    });
    return unregister;
  }, [tourId, tour]);

  // Auto-start on first visit
  useEffect(() => {
    if (isTourCompleted(tourId)) return;

    const timer = setTimeout(() => {
      tour.start();
    }, delay);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourId]);

  return tour;
}
